import { createStore } from 'vuex'
import axios from 'axios'
import * as d3 from 'd3';

export default createStore({
	state: {
		messages: [],
	},
	mutations: {
		SAVE_DATA (state, data) {
			console.log("store: ", data);
			state.messages = data[0];
		}, 
	},
	getters: {
		// articleItems: state => state.articles
	},
	actions: {
		loadData ({ commit, state }) {
			console.log("environment: ", process.env.NODE_ENV, "public: ", process.env.public, "app base: ", process.env.VUE_APP_BASE, "versie 4");

			const path = process.env.NODE_ENV === "production" ? process.env.VUE_APP_BASE : '';

			return new Promise((resolve, reject) => { 
				Promise.all([
					d3.dsv(';', path + '/data/messages.csv')
				])
				.then(result => {
					console.log("data geladen");
					commit("SAVE_DATA", result);
					resolve();
				})
				.catch(error => {
					reject();
					throw new Error(`API ${error}`);
				});
			})
		},    
	},
	modules: {

	}
})
